var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"time_box fcc"},[_vm._m(0),_c('div',[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"box"},[_c('span',[_vm._v(_vm._s(_vm.date))]),_c('span',[_vm._v(_vm._s(_vm.week))])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"45px"},attrs:{"src":require("../assets/image/time.png"),"alt":""}})])
}]

export { render, staticRenderFns }